import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=120f9b80&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('120f9b80')) {
      api.createRecord('120f9b80', component.options)
    } else {
      api.reload('120f9b80', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=120f9b80&", function () {
      api.rerender('120f9b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ix918rsNzVKp/JS/pricehelp.vue"
export default component.exports